import React from 'react'
import {Link} from 'react-router-dom'

import withApiService from '../../hoc/with-api-service'
import withData from '../../hoc/with-data'

const BasketPanelCard = ({response, id, size, amount, handleDeleteClick}) => {
  const {data} = response;

  return (
    <div className="product-list__item"
         key={`${id}` + size}>
      <Link to={`/product-card-desktop/${id}`} className="product-list__pic">
        <img src={data && data.images[0]} alt="product"/> </Link>
      <Link to={`/product-card-desktop/${id}`} className="product-list__product">
        {data && data.title}
        {` (размер: ${size})`}
        {amount > 1 && `, ${amount} шт.`}
      </Link>
      <div className="product-list__fill"/>
      <div className="product-list__price">{data && (data.price * amount).toLocaleString('ru-RU')}
        <i className="fa fa-rub" aria-hidden="true"/>
      </div>
      <div className="product-list__delete"
           onClick={handleDeleteClick}>
        <i className="fa fa-times"
           aria-hidden="true"
           id={`${id}-${size}`}/>
      </div>
    </div>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProduct
  };
};

export default withApiService(mapMethodsToProps)(withData(BasketPanelCard))
